import React, { Component } from 'react';
import './index.css';
import AuthService from '../../components/AuthService';
import { createBrowserHistory } from 'history';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import 'moment/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import {
  Form,
  Input,
  Select,
  Button,
  message,
  Card,
  Alert
} from 'antd';
const history = createBrowserHistory();


const { Option } = Select;

class ResetPassword extends Component {
  formRef = React.createRef();

  state = {
    password: "",
    confirmDirty: false,
    error: false,
    message: "",
  }

  captcha = undefined;

  static defaultProps = {
    auth: new AuthService()
  };
  // static getDerivedStateFromProps(props, state) {
  componentWillMount() {
    const { auth } = this.props

    auth.fetch('/api/recaptcha/site').then(res => {
      if (res && res.data) {
        this.setState({ recaptchaSite: res.data });
      }
    });

    var nurl = new URL(window.location.href);
    var token = nurl.searchParams.get("token");
    auth.fetch('/api/reset-password-valid?token='+token).then(res => {
      if (!res || !res.status) {
        this.setState({error: true, message: res.message})
      }
    });
  }

  handleSubmit = (values) => {
    const { auth } = this.props

    // e.preventDefault();
    // this.formRef.current.validateFieldsAndScroll((err, values) => {
    //   if (!err) {
    //     e.preventDefault();
    // console.log(values);
    this.props.auth.resetPassword(values)
      .then(res => {
        if (!res.status) {
          if (this.captcha) {
            this.captcha.reset();
          }
          //Валидация (подумать как сделать универсально)
          //Чистим ошибки предыдущей валидации
          this.formRef.current.setFieldsValue(this.formRef.current.getFieldsValue());
          //Показываем новые ошибки
          if (res.invalid && res.invalid.errors) {
            var object = res.invalid.errors
            for (const key in object) {
              if (object.hasOwnProperty(key)) {
                const element = object[key];
                if (element && element.length) {
                  var valData = [];
                  valData.push({
                    name: key,
                    errors: [element[0].message],
                    value: (element[0].value) ? element[0].value : ""
                  })
                  this.formRef.current.setFields(valData);
                }
              }
            }
          }
          
          this.setState({error: true, message: res.message});
        } else {
          window.location.href = auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href);
        }
      })
      .catch(err => {
        if (this.captcha) {
          this.captcha.reset();
        }
        // message.error(err);
        console.log(err)
      })
    //     return false;
    //   }
    // });
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div style={{
        height: "calc(100vh - 12px)",
        backgroundColor: (this.props.mobile) ? "white" : "#f5f5f5",
        margin: "5px",
        borderRadius: "5px"
      }}>
        
        <div style={{paddingTop: "25px", textAlign: "center"}}>
          <a href="/">
            <img src="/resources/logo.svg" alt="Logo" />
          </a>
        </div>

        {!this.state.error && <Form ref={this.formRef} name="resetPassword" {...formItemLayout}
          onFinish={this.handleSubmit}
          onFinishFailed={({ errorFields }) => {
            this.formRef.current.scrollToField(errorFields[0].name);
          }}
          className="register-form"
          style={{ maxWidth: (this.props.mobile) ? "300px" : "600px", paddingTop: "5px" }}
          
          initialValues={{
            genderID: '1',
            tipTelefonaID: '1',
          }}
        >
          <div style={{
            backgroundColor: "white",
            padding: (this.props.mobile) ? "0px" : "25px",
            boxShadow: "1px 1px 8px 0px rgba(34, 60, 80, 0.2)",
            borderRadius: "5px"
          }}>

            <Form.Item label="Новый пароль" hasFeedback
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Пожалуйста, введите пароль не меньше 8 символов!',
                },
                {
                  min: 8,
                  message: 'Пожалуйста, введите пароль не меньше 8 символов!',
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item label="Повторите пароль" hasFeedback
              name="confirm"
              dependencies={['password']}
              rules={[
                {
                  required: true,
                  message: 'Пожалуйста, повторите ваш пароль!',
                },
                {
                  min: 8,
                  message: 'Пожалуйста, повторите ваш пароль!',
                },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject('Пароли не совпадают!');
                  },
                }),
              ]}
            >
              <Input.Password onBlur={this.handleConfirmBlur} />
            </Form.Item>

            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Изменить
          </Button>
            </Form.Item>
          </div>
        </Form>}
        {this.state.error && <div className="register-form">
          <Card>
            <Alert
              message="Ошибка изменения пароля"
              description={this.state.message}
              type="error"
              showIcon
            />
            <div style={{paddingTop: "25px"}}>
              <a href="/app/login">Вернуться на страницу входа</a>
            </div>
          </Card>
        </div>}
      </div>
    );
  }
}

export default ResetPassword;